import { useEffect, useRef,useState} from "react";
import { getToken, getUserId } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import PoppinsRegularBase64 from '../fonts/Poppins-Regular.js';
import PoppinsBoldBase64 from '../fonts/Poppins-Bold.js';
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs'
import {convertiIdInventario,getLinguaMessaggio,getIDLingua,ordinaPerData,prendiNomePacchetto,coloreDaId,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
import { RRule, rrulestr } from 'rrule';
import meteo from "../funzioni/previsionimeteo"
/* global $ */
/* global jsPDF */
/* global DevExpress */
let meteoCache = null;
function Agenda(){
let modificaForm=false
    let daEliminare=null
function isException(startDate, exceptions) {
  return exceptions.some(exc => exc.equals(startDate));
}
function generaBottoni(){
    const div=document.createElement("div")
    const botPlan=document.createElement("div")
    botPlan.id="bottonePlan"
    const botCust=document.createElement("div")
    botCust.id="bottoneClienti"

}
async function generaTabellaMessaggi(utenti){
    const divTabella = document.createElement("div")
    divTabella.id="gridContainerMessaggi"
    const totali=$("#schedulerElement").dxScheduler("instance").option("dataSource")
    let pacchettiPlan=[]
    let mappaMes
    for (let lezione of totali){
        const mappaMes={0:`Hi ${lezione.text}! Your lesson is scheduled on ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('dd/MM/yyyy')} from ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('HH:mm')} to ${DateTime.fromJSDate(lezione.endDate, { zone: 'utc' }).toFormat('HH:mm')}, your instructor will be ${nome_id({id:lezione.userid,utenti:utenti,nomeOnly:true})}. We can't wait to see you on the beach! Reply "OK" to confirm your booking.`,
                    1:`Ciao ${lezione.text}! La tua lezione è programmata per il ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('dd/MM/yyyy')} dalle ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('HH:mm')} alle ${DateTime.fromJSDate(lezione.endDate, { zone: 'utc' }).toFormat('HH:mm')}, il tuo istruttore sarà ${nome_id({id: lezione.userid, utenti: utenti,nomeOnly:true})}. Non vediamo l'ora di vederti in spiaggia! Rispondi "OK" per confermare la prenotazione.`,
                        2:`Salut ${lezione.text}! Ta leçon est prévue le ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('dd/MM/yyyy')} de ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('HH:mm')} à ${DateTime.fromJSDate(lezione.endDate, { zone: 'utc' }).toFormat('HH:mm')}, ton instructeur sera ${nome_id({id: lezione.userid, utenti: utenti,nomeOnly:true})}. Nous avons hâte de te voir sur la plage! Réponds "OK" pour confirmer la réservation.`,
                        3:`Hallo ${lezione.text}! Deine Stunde ist am ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('dd/MM/yyyy')} von ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('HH:mm')} bis ${DateTime.fromJSDate(lezione.endDate, { zone: 'utc' }).toFormat('HH:mm')} geplant. Dein Lehrer wird ${nome_id({id: lezione.userid, utenti: utenti,nomeOnly:true})} sein. Wir freuen uns darauf, dich am Strand zu sehen! Antworte mit "OK", um die Buchung zu bestätigen.`,
                        4:`¡Hola ${lezione.text}! Tu clase está programada para el ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('dd/MM/yyyy')} de ${DateTime.fromJSDate(lezione.startDate, { zone: 'utc' }).toFormat('HH:mm')} a ${DateTime.fromJSDate(lezione.endDate, { zone: 'utc' }).toFormat('HH:mm')}, tu instructor será ${nome_id({id: lezione.userid, utenti: utenti,nomeOnly:true})}. ¡Nos vemos en la playa pronto! Responde "OK" para confirmar tu reserva.`,

                    }
        pacchettiPlan.push({inizio:lezione.startDate,fine:lezione.endDate,istruttore:lezione.userid,id:lezione.id,nome:lezione.text,telefono:lezione.telefono,lingua:lezione.lingua,messaggio:mappaMes[lezione.lingua]})
    }
    setTimeout(()=>{


        $("#gridContainerMessaggi").dxDataGrid({
            dataSource:pacchettiPlan,
            keyExpr: "id",
              selection: {
                mode: "multiple",
            },
            editing: {
    mode: "popup",     // oppure "cell" o "popup"
    allowUpdating: true,
    allowAdding: false,
    allowDeleting: false,
    popup: {
            title: "Informazioni studente",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",}
  },
            columns:[
            {dataField: "nome",
          caption: "Nome studente",
          hidingPriority:4,
          alignment:"center",},
          {dataField: "telefono",
          caption: "Telefono",
          hidingPriority:3,
          alignment:"center",},
          {dataField: "lingua",
          caption: "Lingua messaggio",
          hidingPriority:2,
          alignment:"center",
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_origine").length===0) {
                $('<div id="val_origine"></div>').appendTo(cellElement)
            }
            let valore_mappa=[{name:"Inglese",ID:0},{name:"Italiano",ID:1},{name:"Francese",ID:2},{name:"Tedesco",ID:3},{name:"Spagnolo",ID:4}]
            $("#val_origine").dxSelectBox({dataSource:valore_mappa ,valueExpr:"ID",displayExpr:"name", value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                 const mappaMes={0:`Hi ${cellInfo.data.nome}! Your lesson is scheduled on ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('dd/MM/yyyy')} from ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('HH:mm')} to ${DateTime.fromJSDate(cellInfo.data.fine, { zone: 'utc' }).toFormat('HH:mm')}, your instructor will be ${nome_id({id:cellInfo.data.istruttore,utenti:utenti,nomeOnly:true})}. We can't wait to see you on the beach! Reply "OK" to confirm your booking.`,
                    1:`Ciao ${cellInfo.data.nome}! La tua lezione è programmata per il ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('dd/MM/yyyy')} dalle ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('HH:mm')} alle ${DateTime.fromJSDate(cellInfo.data.fine, { zone: 'utc' }).toFormat('HH:mm')}, il tuo istruttore sarà ${nome_id({id: cellInfo.data.istruttore, utenti: utenti,nomeOnly:true})}. Non vediamo l'ora di vederti in spiaggia! Rispondi "OK" per confermare la prenotazione.`,
                        2:`Salut ${cellInfo.data.nome}! Ta leçon est prévue le ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('dd/MM/yyyy')} de ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('HH:mm')} à ${DateTime.fromJSDate(cellInfo.data.fine, { zone: 'utc' }).toFormat('HH:mm')}, ton instructeur sera ${nome_id({id: cellInfo.data.istruttore, utenti: utenti,nomeOnly:true})}. Nous avons hâte de te voir sur la plage! Réponds "OK" pour confirmer la réservation.`,
                        3:`Hallo ${cellInfo.data.nome}! Deine Stunde ist am ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('dd/MM/yyyy')} von ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('HH:mm')} bis ${DateTime.fromJSDate(cellInfo.data.fine, { zone: 'utc' }).toFormat('HH:mm')} geplant. Dein Lehrer wird ${nome_id({id: cellInfo.data.istruttore, utenti: utenti,nomeOnly:true})} sein. Wir freuen uns darauf, dich am Strand zu sehen! Antworte mit "OK", um die Buchung zu bestätigen.`,
                        4:`¡Hola ${cellInfo.data.nome}! Tu clase está programada para el ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('dd/MM/yyyy')} de ${DateTime.fromJSDate(cellInfo.data.inizio, { zone: 'utc' }).toFormat('HH:mm')} a ${DateTime.fromJSDate(cellInfo.data.fine, { zone: 'utc' }).toFormat('HH:mm')}, tu instructor será ${nome_id({id: cellInfo.data.istruttore, utenti: utenti,nomeOnly:true})}. ¡Nos vemos en la playa pronto! Responde "OK" para confirmar tu reserva.`,

                    }
                    $("#val_messaggio").dxTextArea("instance").option("value",mappaMes[e.value])
                },
            elementAttr: {
                class: "istruttore-style"
              },
            })
          },
          customizeText:function(e){
            return getLinguaMessaggio(e.value)
          }},
                {dataField: "messaggio",
          caption: "Messaggio",
          hidingPriority:1,
            editCellTemplate:function (cellElement,cellInfo) {
                if ($("#val_messaggio").length===0) {
                $('<div id="val_messaggio"></div>').appendTo(cellElement)
            }
            $("#val_messaggio").dxTextArea({ value:cellInfo.value,onValueChanged: function(e) {
            cellInfo.setValue(e.value)},
            })
            },
                }
            ],
            onInitialized: function(e){
                e.component.selectAll();
            },
        })
    },0)
    return divTabella
}
async function mandaPlan(utenti){
    const contenuto =document.createElement("div")
    const isMobile = window.innerWidth <= 768; // soglia tipica
    if (!isMobile){
    Object.assign(contenuto.style, {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});

}
const dataA=DateTime.fromJSDate($("#schedulerElement").dxScheduler("instance").option("currentDate")).toFormat("yyyyMMdd")
const dataF=DateTime.fromJSDate($("#schedulerElement").dxScheduler("instance").option("currentDate")).toFormat("dd/MM/yyyy")
const rispS=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: 'buildLessonsPlan',
                         date:dataA,
                      });
    const pulsanteSalva=document.createElement("div")
    pulsanteSalva.id="pulsanteScarica"
    const pulsanteChiudi=document.createElement("div")
    pulsanteChiudi.style.marginLeft="2px"
    if (isMobile){
        pulsanteChiudi.style.marginTop="2px"
    }
    contenuto.appendChild(pulsanteSalva)
    contenuto.appendChild(pulsanteChiudi)

    pulsanteChiudi.id="pulsanteInvia"
    setTimeout(()=>{
        $("#pulsanteScarica").dxButton({
        text: "Scarica PDF",
  type: "default",
  icon: "user",
  onClick: async function (e){
       if (rispS.pdffiledata){
            const base64PDF=rispS.pdffiledata
            // Converti la stringa base64 in un blob
const byteCharacters = atob(base64PDF);
const byteNumbers = new Array(byteCharacters.length);
for (let i = 0; i < byteCharacters.length; i++) {
  byteNumbers[i] = byteCharacters.charCodeAt(i);
}
const byteArray = new Uint8Array(byteNumbers);
const blob = new Blob([byteArray], { type: "application/pdf" });

// Crea un link temporaneo per il download
const link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = `Lesson_plan_${dataF}.pdf`; // nome del file
document.body.appendChild(link);
link.click();

// Pulisci il DOM
document.body.removeChild(link);
URL.revokeObjectURL(link.href);
       }
  }
  })
  $("#pulsanteInvia").dxButton({
        text: "Manda al gruppo",
  type: "default",
  icon: "email",
  onClick: async function (e){
  if (rispS.pdffiledata){
    await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: 'sendWhatsappDoc',
                         valori:{"whatsappdocbody":rispS.pdffiledata,"whatsappdocfname":`Lesson_plan_${dataF}`,"whatsappmsg":btoa(new TextEncoder().encode(`Lesson plan for ${dataF}`)
  .reduce((data, byte) => data + String.fromCharCode(byte), '')
),"whatsappcontacts":["+393452969090"]}
                      });

                  }
  }
  })
    },0)
    return contenuto
}

async function scegliSMS(){
    const utenti= await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
    const contenuto =document.createElement("div")
    const isMobile = window.innerWidth <= 768; // soglia tipica
    if (!isMobile){
    Object.assign(contenuto.style, {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
});}
    const pulsanteSalva=document.createElement("div")
    pulsanteSalva.id="pulsanteSalva"
    const pulsanteChiudi=document.createElement("div")
    contenuto.appendChild(pulsanteSalva)
    contenuto.appendChild(pulsanteChiudi)
    pulsanteChiudi.style.marginLeft="2px"
    if (isMobile){
        pulsanteChiudi.style.marginTop="2px"
    }
    pulsanteChiudi.id="pulsanteChiudi"
    setTimeout(()=>{
        $("#pulsanteSalva").dxButton({
        text: "Manda al gruppo",
  type: "default",
  icon: "user",
  onClick: async function (e){
    confermaSMS2(utenti)
  }
  })
  $("#pulsanteChiudi").dxButton({
        text: "Avvisa Clienti",
  type: "default",
  icon: "email",
  onClick: async function (e){
    confermaSMS(utenti)
  }
  })
    },0)
    $("#confermaSMSPlan").dxPopup("instance").option( "title",`A chi vuoi mandare i messaggi?`);
    $("#confermaSMSPlan").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#confermaSMSPlan").dxPopup("instance").option( "toolbarItems", [ {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#confermaSMSPlan").dxPopup("instance").hide();
        },
      },
    }],)
    $("#confermaSMSPlan").dxPopup("instance").show();
}
async function confermaSMS(utenti){
    const contenuto = await generaTabellaMessaggi(utenti)
    $("#confermaSMS").dxPopup("instance").option( "title",`Conferma l'invio dei messaggi`);
    $("#confermaSMS").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#confermaSMS").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Conferma',
        onClick: async function () {
            $("#loadingOverlay").show()
            const grid=$("#gridContainerMessaggi").dxDataGrid("instance");
            const messaggi = grid.getSelectedRowsData()
            for (let messaggio of  messaggi){
             const testo=messaggio.messaggio
                console.log(messaggio)
                await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        azione: 'sendWhatsappMsg',
                         group:"lessons",
                         valori:{"whatsappmsg":btoa(new TextEncoder().encode(testo)
  .reduce((data, byte) => data + String.fromCharCode(byte), '')
),"whatsappcontacts":[messaggio.telefono]}
                      });
            }
            $("#confermaSMS").dxPopup("instance").hide();
            $("#loadingOverlay").hide()
            }
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#confermaSMS").dxPopup("instance").hide();
        },
      },
    }],)
    $("#confermaSMS").dxPopup("instance").show();
}
async function confermaSMS2(utenti){
    const contenuto = await mandaPlan(utenti)
    $("#confermaSMS2").dxPopup("instance").option( "title",`Conferma l'invio dei messaggi`);
    $("#confermaSMS2").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#confermaSMS2").dxPopup("instance").option( "toolbarItems", [ {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#confermaSMS2").dxPopup("instance").hide();
        },
      },
    }],)
    $("#confermaSMS2").dxPopup("instance").show();
}
function getOccurrences(appointment, rangeStart, rangeEnd) {

  // Crea l’RRULE a partire dalla stringa

  const untilFormatted = ((appointment.startDate).toISOString()).replace(/[-:]|\.\d{3}/g, "")
  const rule = rrulestr(`DTSTART:${untilFormatted}\nRRULE:${appointment.recurrenceRule}`);
  const appunt=rule.all()
  var appuntLuxon=[]
  const durata=DateTime.fromJSDate(appointment.endDate, { zone: 'utc' }).diff(DateTime.fromJSDate(appointment.startDate, { zone: 'utc' }))
  var eccezioni=[]
  if (appointment.recurrenceException){
  eccezioni=appointment.recurrenceException.split(",").map(dateStr =>
    DateTime.fromFormat(dateStr.trim(), "yyyyLLdd'T'HHmmss'Z'", { zone: 'utc' })
  );}
  for (let i of appunt){
  if ((DateTime.fromJSDate(i, { zone: 'utc' })<=rangeEnd && DateTime.fromJSDate(i, { zone: 'utc' })>=rangeStart) && !isException(DateTime.fromJSDate(i, { zone: 'utc' }),eccezioni))
  appuntLuxon=[...appuntLuxon,{startDate:DateTime.fromJSDate(i, { zone: 'utc' }).toFormat('yyyyMMddHHmm'),endDate:DateTime.fromJSDate(i, { zone: 'utc' }).plus(durata).toFormat('yyyyMMddHHmm'),userid:appointment.userid}]
  }
  return appuntLuxon
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
async function loadMeteo() {
    if (!meteoCache) {
        // Qui fai la tua fetch o assegni i dati statici
        meteoCache = meteo()
    }
    return meteoCache;
}
async function getAltezzaInterpolata(hour, day) {

    const meteoTot = await loadMeteo();
    const meteoData = meteoTot[day];
    if (meteoData){
        if (!meteoData) return null;

        const keys = Object.keys(meteoData).map(Number).sort((a, b) => a - b);
        let prev = keys[0], next = keys[keys.length - 1];

        for (let i = 0; i < keys.length - 1; i++) {
            if (hour >= keys[i] && hour < keys[i + 1]) {
                prev = keys[i];
                next = keys[i + 1];
                break;
            }
        }

        const hPrev = parseFloat(meteoData[prev].marea.altezza);
        const hNext = parseFloat(meteoData[next].marea.altezza);

        if (isNaN(hPrev) || isNaN(hNext)) return null;

        const ratio = (hour - prev) / (next - prev);
        let picco=null
        for (let ora in meteoData){
            if (meteoData[ora].marea.ora){
                const [h, min] = meteoData[ora].marea.ora.split(":").map(Number);
                const oraFloat = h + min / 60;
                if (oraFloat >= hour && oraFloat < hour+0.5) {
                    if (meteoData[ora].marea.tipo === "high") picco = "max";
                    else if (meteoData[ora].marea.tipo === "low") picco = "min";
                }

            }
        }
        return [hPrev + (hNext - hPrev) * ratio,picco];
    }
}

function parseToRow(iso) {
  const yyyy = iso.slice(0, 4), MM = iso.slice(4, 6), dd = iso.slice(6, 8);
  const HH = iso.slice(9, 11), mm = iso.slice(11, 13);
  return {
    iso,
    data: `${dd}/${MM}/${yyyy}`,
    ora: `${HH}:${mm}`
  };
}

function toISOString(dateObj) {
  const yyyy = dateObj.getUTCFullYear();
  const MM = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getUTCDate()).padStart(2, '0');
  const HH = String(dateObj.getUTCHours()).padStart(2, '0');
  const mm = String(dateObj.getUTCMinutes()).padStart(2, '0');
  return `${yyyy}${MM}${dd}T${HH}${mm}00Z`;
}
async function updateHidden(id) {
  const grid = $("#gridContainerEccezioni").dxDataGrid("instance");
  const allData = grid.getDataSource().items();
  const isoList = allData.map(r => r.iso);
  let nuovaStringa=isoList.join(",");
  if (!nuovaStringa){
  nuovaStringa=null
  }
  const dati_n={"lessondaterecurrenceexception":nuovaStringa }
  $("#loadingOverlay").show()
    var richiesta=await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                valori:dati_n,
                setId:id,
                azione:'setLessonDate'})
  $("#loadingOverlay").hide()
}
function modificaEccezioniF(dati){
const allineamento="center"
  const eccezioniArray = dati.recurrenceException
  .split(",")
  .filter(x => x.trim() !== "")
  .map(parseToRow);
  const div = document.createElement("div");
  div.style.padding = "0px";
  const inner = document.createElement("div");
  inner.id = "gridContainerEccezioni";

  const commento = document.createElement("p");
  commento.innerText = `Eccezioni alle lezioni ricorrenti di ${dati.text}`
  commento.style.marginTop = "10px";
  commento.style.fontSize = "24px";
  commento.style.fontFamily = "Poppins, sans-serif";
  div.appendChild(inner);
    setTimeout(() => {
        const tabellaEccezioni=$("#gridContainerEccezioni").dxDataGrid({
            dataSource: eccezioniArray,
  keyExpr: "iso",
  editing: {
    mode: "popup",
    allowAdding: false,
    allowDeleting: true,
    allowUpdating: false
  },
  columns: [
    { dataField: "data", caption: "Data", allowEditing: false },
    { dataField: "ora", caption: "Ora", allowEditing: false },
    { dataField: "iso", visible: false },
    {
      type: "buttons",
      buttons: [{
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              }]
    }
  ],
  onRowRemoved: function (e) {
    updateHidden(dati.id);
  }
        })
    },0)
  $("#modificaEccezioni").dxPopup("instance").option(
            "title",
            `Dettagli eccezioni di ${dati.text}`
          );
          $("#modificaEccezioni").dxPopup("instance").option("contentTemplate", () => div);
          $("#modificaEccezioni").dxPopup("instance").show();

}
function confermaEliminazione(dati){
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `Sei sicuro di volere eliminare la lezione di ${dati.text}?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#confermaElimina").dxPopup("instance").option( "title",`Conferma eliminazione lezione di ${dati.text}`);
    $("#confermaElimina").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#confermaElimina").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick() { $("#confermaElimina").dxPopup("instance").hide();
        $("#schedulerElement").dxScheduler("instance").deleteAppointment(dati);

        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#confermaElimina").dxPopup("instance").hide();
        },
      },
    }],)
    $("#confermaElimina").dxPopup("instance").show();
    }
    function trovaIdDuplicati(lista){
        const gruppi = {};

        // Raggruppa per ID
        for (const elem of lista) {
          if (!gruppi[elem.id]) {
            gruppi[elem.id] = [];
          }
          gruppi[elem.id].push(elem);
        }

        // Tieni solo quelli con ID duplicati
        const duplicati = {};
        for (const id in gruppi) {
          if (gruppi[id].length > 1) {
            duplicati[id] = gruppi[id];
          }
        }

        return duplicati
    }
function rimuoviDataSource(dataSource){
    var duplici=trovaIdDuplicati(dataSource)
    if (Object.keys(duplici)[0]){
        for (let i of duplici[Object.keys(duplici)[0]]){
            if (!i.recurrenceRule){
            dataSource.splice(dataSource.indexOf(i),1)
            return i
            }
        }
    }

}
async function modificaKite(inventario,nome,inizio,fine,tipoT,idDatabase,idLezione){
    $("#loadingOverlay").show()
    const inizio_2=DateTime.fromJSDate(inizio);
    const fine_2=DateTime.fromJSDate(fine);
    const materiale_disp= await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:[inventario[0],inventario[1],inventario[2]]})
    const contenuto = document.createElement("div");
const primaRiga = document.createElement("div");
const secondaRiga = document.createElement("div");
contenuto.appendChild(primaRiga);
contenuto.appendChild(secondaRiga);
// Stili per la riga
primaRiga.style.display = "flex";
primaRiga.style.flexDirection = "row";
primaRiga.style.justifyContent = "space-between";
primaRiga.style.alignItems = "center";
secondaRiga.style.display = "flex";
secondaRiga.style.flexDirection = "row";
secondaRiga.style.justifyContent = "space-between";
secondaRiga.style.alignItems = "center";
secondaRiga.style.paddingTop = "20px";


// Crea contenitori vuoti
const kiteDiv = document.createElement("div");
const barraDiv = document.createElement("div");

// Inizializza dxSelectBox usando jQuery
$(kiteDiv).dxLookup({
  dataSource: materiale_disp[1],
  placeholder: "Kite...",
  label:"Modifica kite",
  searchEnabled:true,
  displayExpr: "nome",
            valueExpr: "ID",
  value: inventario[0],

  width: "45%"

});

$(barraDiv).dxLookup({
  dataSource: materiale_disp[2],
  placeholder: "Barra...",
  label:"Modifica barra",
  searchEnabled:true,
  displayExpr: "nome",
            valueExpr: "ID",
  value: inventario[1],
   width: "45%" // suppongo qui volevi [1] invece di [0]?
});

// Aggiungi al DOM
primaRiga.appendChild(kiteDiv);
primaRiga.appendChild(barraDiv);

// Creo i due div figli
const div1 = document.createElement("div");
const div2 = document.createElement("div");

// Aggiungo id o classi per referenziarli facilmente
div1.id = "tavolaT";
div2.id = "tavola";
secondaRiga.appendChild(div1);
secondaRiga.appendChild(div2);

// Ora inizializzo le dxSelectBox dentro i div (usando jQuery)
let dati_ut = [];
    for (let i = 3; i <= 5; i++) {
      dati_ut.push({ ID: i, nome: convertiIdInventario(i) });
    }
$(div1).dxLookup({
  dataSource: dati_ut,
  displayExpr: "nome",
  label:"Modifica tipo tavola",
  valueExpr: "ID",
  searchEnabled:true,
  value:tipoT,
  placeholder: "Tipo Tavola...",
  width:"45%",

});
$(div2).dxLookup({
  dataSource: materiale_disp[tipoT],
  label:"Modifica tavola",
  placeholder: "Tavola...",
  displayExpr: "nome",
  valueExpr: "ID",
  searchEnabled:true,
  value: inventario[2],
  width:"45%",
});

// Inizialmente nascondo il secondo div

// Creo uno switch (con DevExtreme) che sta fuori secondaRiga
    $("#modificaMateriale").dxPopup("instance").option( "title",`Modifica materiale di ${nome}`);
    $("#modificaMateriale").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaMateriale").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () { $("#modificaMateriale").dxPopup("instance").hide();

        var contatore=0
        const mappaValori={0:kiteDiv,1:barraDiv,2:div2}
            for (let idKite of idDatabase){
                const divInt=mappaValori[contatore]
            //Kite: se non c'è, o c'è ma è diverso, aggiungo/modifico, se il campo è vuoto ma c'è nel DB elimino, se non c'è e il campo è vuoto faccio nulla
                if ((!idKite || inventario[contatore]!==$(divInt).dxLookup("instance").option("value")) && ($(divInt).dxLookup("instance").option("value"))) {
                    if (!idKite) {
                    const dati_n={"inventoryid": $(divInt).dxLookup("instance").option("value"), "lessondateid":idLezione }
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    azione:'setLinkLessonDateInv'
                  });
                    }
                    else {
                        const dati_n={"inventoryid": $(divInt).dxLookup("instance").option("value"), "lessondateid":idLezione }
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    setId:idKite,
                    azione:'setLinkLessonDateInv'})
                    }
                }
                if (!$(divInt).dxLookup("instance").option("value") && idKite) {
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    delId:idKite,
                    azione:'delLinkLessonDateInv'})
                }
            contatore+=1
            }
            fetchData()


        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaMateriale").dxPopup("instance").hide();
        },
      },
    }],)
    $("#modificaMateriale").dxPopup("instance").show();
    $("#loadingOverlay").hide()


}
async function modificaStatus(datiPrima) {

    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = datiPrima.stato ===1 ? `Sei sicuro di volere confermare la lezione di ${datiPrima.text}?` : `Sei sicuro di voler programmare la lezione di ${datiPrima.text}?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontWeight = "bold";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#modificaLezione").dxPopup("instance").option( "title",`Conferma modifica di stato lezione`);
    $("#modificaLezione").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaLezione").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () { $("#modificaLezione").dxPopup("instance").hide();
        const dati_n={"lessondatestatus":datiPrima.stato ===1 ? 2 : 1 }
        var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    setId:datiPrima.id,
                    azione:'setLessonDate'})
        fetchData()
        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaLezione").dxPopup("instance").hide();}
      },
    }],)
    $("#modificaLezione").dxPopup("instance").show();
}
function confermaModifica(datiPrima,datiOra) {
setTimeout(()=>{
$("#loadingOverlay").hide()},0)
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `Sei sicuro di volere modificare la lezione di ${datiPrima.text}?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontWeight = "bold";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#modificaLezione").dxPopup("instance").option( "title",`Conferma modifica di ${datiPrima.text}`);
    $("#modificaLezione").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaLezione").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick() { $("#modificaLezione").dxPopup("instance").hide();
        fetchData()
        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaLezione").dxPopup("instance").hide();
          const schedulerInstance = $("#schedulerElement").dxScheduler("instance");
          modificaForm=true
          if (datiPrima.recurrenceRule){
          daEliminare=rimuoviDataSource($("#schedulerElement").dxScheduler("instance").option("dataSource"))}

const dataSourceItems = schedulerInstance.getDataSource().items();
const matchingEvent = dataSourceItems.find(item => item.id === datiOra.id);
schedulerInstance.updateAppointment(matchingEvent, {...matchingEvent, ...datiPrima})
        },
      },
    }],)
    $("#modificaLezione").dxPopup("instance").show();
}
  useEffect(() => {
    $("#schedulerElement").dxScheduler({
      dataSource: [],
      views: ['day', 'week', 'month'],
      currentView: 'day',
      currentDate: new Date(),
      height: "auto",
       timeZone: "UTC",
      editing: {
  allowAdding: true,
  allowDeleting: true,
  allowUpdating: true,
  allowRecurrence: true // ✅ questo è necessario per visualizzare e gestire le ricorrenze
},
      showAllDayPanel: false,
      crossScrollingEnabled:false,
      resources: [{
        fieldExpr: "userid",
        dataSource: [],
        label: "Istruttore"
      }],
      groups: ['userid'],
      crossScrollingEnabled: true,
      textExpr: 'text',
      onAppointmentUpdating: function(e) {
      if (!modificaForm){
      confermaModifica(e.oldData, e.newData)
      }
},
      onAppointmentFormOpening: async function (e) {
      const originalData = { ...e.appointmentData };
      const form = e.form;
      e.popup.option('width', "80%");
      for (let i of form.option('items')[0]["items"]){if (i.dataField==="description") {form.option('items')[0]["items"].splice(form.option('items')[0]["items"].indexOf(i),1)}}
      if (e.form.option('items')[0]["items"][2]["items"].length>1)
      e.form.option('items')[0]["items"][2]["items"].splice(0,1)
      $("#loadingOverlay").show()
      modificaForm=true
      const popupInstance = e.popup;
     setTimeout(async ()=>{
     // recupero i bottoni del popup
     const popup = e.popup;
let items = popup.option("toolbarItems") || [];

items = items.map(item => {
  const sc = item.shortcut;
  // assicurati che esista options
  item.options = item.options || {};

  // ---- CANCEL ----
  if (sc === "cancel") {
    const old = item.options.onClick; // può essere undefined su iOS/adaptive
    item.options.text = "Annulla";
    item.options.onClick = function(ev) {
      if (typeof old === "function") {
        old.call(this, ev);              // comportamento nativo
      } else {
        popup.hide();                    // ✅ fallback: chiudi il popup
      }
      modificaForm = false;              // tua logica
    };
  }

  // ---- DONE (SALVA) ----
  if (sc === "done") {
    const old = item.options.onClick;    // di solito esiste
    item.options.text = "Salva";
    if (typeof old === "function") {
      item.options.onClick = function(ev) {
        old.call(this, ev);              // mantieni submit/validazione nativa
      };
    }
    // se non c'è old, NON toccare onClick per non rompere il submit
  }

  return item;
});

popup.option("toolbarItems", items);
for (let i of e.form.option('items')[0]["items"]){
        if ("items" in i) {
            for (let j of i["items"]){
                if (j.label.text==="Repeat"){
                    const oldOnValueChanged = j.editorOptions.onValueChanged;
                    j.editorOptions.onValueChanged = function(e) {
                      if (typeof oldOnValueChanged === "function") {
                        oldOnValueChanged.call(this, e);
                      }
                    $("#val_mod_mat_switch").dxSwitch("option","disabled",e.value)
                    if (e.value) {$("#val_mod_mat_switch").dxSwitch("option","value",false)}
                    $("#val_mod_mat_switch").dxSwitch("option","disabled",e.value)
                    $("#val_status").dxSelectBox("option","disabled",e.value)
                    $("#val_status").dxSelectBox("option","value",1)

                    }

                }
            }
        }
      }



      let dati_ut = [];
    for (let i = 3; i <= 5; i++) {
      dati_ut.push({ ID: i, nome: convertiIdInventario(i) });
    }

      const inizio_2=DateTime.fromJSDate(e.appointmentData.startDate);
      const fine_2=DateTime.fromJSDate(e.appointmentData.endDate);
      const dati_material = []
      const dati_barra = []
      const dati_tavola = []
      const datiAppuntamento = e.appointmentData
      const tipo_box={ colCountByScreen:{lg: 2, xs: 2},
        colSpan:2,
        itemType:"group",
        name: "gruppoMateriale",
        items:[
          {
        visible:false,
        name: "kite_us",
        label:{text:"Kite"},
          editorType: "dxLookup",
          dataField:"Kite",
          editorOptions: {
          useItemTextAsTitle:true,
          searchEnabled:true,
            dataSource: dati_material,
            displayExpr: "nome",
            valueExpr: "ID",
            elementAttr: {
                id: "val_kite"
              }
          }},{
        visible:false,
        name: "barra_us",
        dataField:"Barra",
        label:{text:"Barra"},
          editorType: "dxLookup",
          editorOptions: {
          useItemTextAsTitle:true,
          searchEnabled:true,
          onFocusOut: function (e) {
    if (e.component.option("text") === "") {
      e.component.option("text", e.component.option("displayValue"));
    }},
            dataSource: dati_barra,
            displayExpr: "nome",
            valueExpr: "ID",
            elementAttr: {
                id: "val_barra"
              }
          }},

          ]
        }

      const tipo2={colCountByScreen:{lg: 2, xs: 2},
        colSpan:2,
        itemType:"group",
        name: "gruppoMateriale2",
        items:[
        {
        visible:false,
        name: "tipo_us",
        dataField:"tipoT",
        label:{text:"Tipo tavola"},
          editorType: "dxLookup",
          editorOptions: {
            dataSource: dati_ut,
            value:e.appointmentData.tipoT?e.appointmentData.tipoT:3,
            displayExpr: "nome",
            valueExpr: "ID",
            onValueChanged: async function(ev) {
             const inizioCa=DateTime.fromJSDate(e.appointmentData.startDate);
      const fineCa=DateTime.fromJSDate(e.appointmentData.endDate);
      const materiali_cambio= await materialeDisponibile({dataInizio:inizioCa,dataFine:fineCa,idEsclusi:[$("#val_tavola").dxLookup("option","value"),$("#val_kite").dxLookup("option","value"),$("#val_barra").dxLookup("option","value")],})
            $("#val_tavola").dxLookup("option","dataSource",materiali_cambio[ev.value])
            },
            elementAttr: {
                id: "val_tipo"
              },
          }},
          {
        visible:false,
        name: "tavola_us",
        dataField:"Tavola",
        label:{text:"Tavola"},
          editorType: "dxLookup",
          editorOptions: {
          useItemTextAsTitle:true,
          searchEnabled:true,
          onFocusOut: function (e) {
    if (e.component.option("text") === "") {
      e.component.option("text", e.component.option("displayValue"));
    }},
    valueChangeEvent: "keyup input change",
            dataSource: dati_tavola,
            displayExpr: "nome",
            valueExpr: "ID",
            elementAttr: {
                id: "val_tavola"
              }
          }}
        ]}

      var ite=form.option('items')
      ite[0]["items"][0]["label"]["text"]="Studente"
      if (ite[0]["items"][0]["editorType"]!=="dxSelectBox"){
      ite[0]["items"][0]["editorType"]="dxSelectBox"

      let dataSourceSel=[]
      let datiPacchetti= await pacchettiAperti()
      for (let i of datiPacchetti){
        dataSourceSel=[...dataSourceSel,{id:i.lessonid,nome:i.lessonstudentname}]
      }
      let ce_nome=false
      for (let i of dataSourceSel) {if (i.id===e.appointmentData.lessonid){ce_nome=true}}
      if (!ce_nome){
      if (e.appointmentData.lessonid){
        dataSourceSel=[...dataSourceSel,{id:e.appointmentData.lessonid,nome:e.appointmentData.text}]}
      }
      ite[0]["items"][0]["editorOptions"]={dataSource: dataSourceSel,
            displayExpr: "nome",
            value:e.appointmentData.lessonid,
            valueExpr: "id",
            searchEnabled:true,
            elementAttr: {
                id: "val_studente"
              }}
      }
      //type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",useMaskBehavior:true,width:"100%"
      ite[0]["items"][1]["items"][0]["editorOptions"]={type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",useMaskBehavior:true,width:"100%",elementAttr: {
                id: "val_inizio"
              },
         onValueChanged: async function (ev){
         const inizio_2=DateTime.fromJSDate(ev.value);
                const fine_2=DateTime.fromJSDate($("#val_fine").dxDateBox("option", "value"))
                const id_esc = [e.appointmentData.Kite,e.appointmentData.Barra,e.appointmentData.Tavola]
               const materiali=await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:id_esc})
               $("#val_kite").dxLookup("option", "dataSource",materiali[1])
         }}
      ite[0]["items"][1]["items"][2]["editorOptions"]={type:"datetime",format: "dd/MM/yyyy HH:mm",displayFormat :"dd/MM/yyyy HH:mm",useMaskBehavior:true,width:"100%",elementAttr: {
                id: "val_fine"
              },
       onValueChanged: async function (ev){
         const inizio_2=DateTime.fromJSDate($("#val_inizio").dxDateBox("option", "value"));
                const fine_2=DateTime.fromJSDate(ev.value)
                const id_esc2=[e.appointmentData.Kite,e.appointmentData.Barra,e.appointmentData.Tavola]
               const materiali=await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:id_esc2})
               $("#val_kite").dxLookup("option", "dataSource",materiali[1])
         }
       }
      const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                azione:'getUsers'
              });
      const inizioIs=(DateTime.fromJSDate(e.appointmentData.startDate)).toMillis();
      const fineIs=(DateTime.fromJSDate(e.appointmentData.endDate)).toMillis()
      const istruttori= await istruttori_disponibili({dataInizio:inizioIs,dataFine:fineIs,id_lezione:e.appointmentData.id,utenti:utenti})
      let datS=[]
      for (let i of istruttori){datS=[...datS,{id:nome_id({nome:i,utenti:utenti}),nome:i}]}
      for (let i of ite[0]["items"]){if (i.itemType==='empty'||i.dataField==="description") {ite[0]["items"].splice(ite[0]["items"].indexOf(i),1)}}

      let numero
      for (let i of ite[0]["items"]){
        if (!(i.items)){
            if (i.dataField==="userid"){
                numero=ite[0]["items"].indexOf(i)
            }
        }
        else {
            for (let j of i["items"]){
                if (j.dataField==="userid"){
                    numero=ite[0]["items"].indexOf(i)
                }
            }
        }
      }
      if (ite[0]["items"][numero].editorOptions){
      ite[0]["items"][numero].editorOptions.dataSource=datS
      ite[0]["items"][numero].editorOptions.displayExpr="nome"
      ite[0]["items"][numero].editorOptions.valueExpr="id"
      ite[0]["items"][numero].editorOptions.value=e.appointmentData.userid}
      else {
        ite[0]["items"][numero]["items"][0].editorOptions.dataSource=datS
      ite[0]["items"][numero]["items"][0].editorOptions.displayExpr="nome"
      ite[0]["items"][numero]["items"][0].editorOptions.valueExpr="id"
      ite[0]["items"][numero]["items"][0].editorOptions.value=e.appointmentData.userid
      }
      let istrutt={}
      for (let i of form.option('items')[0]["items"]){ if (i.dataField==="userid") {istrutt=i
       ite[0]["items"].splice(ite[0]["items"].indexOf(i),1)
       }}
      let ce=false
      let ce2=false
      let ce3=false
      for (let i of ite[0]["items"]){
        if ("items" in i){
            for (let j of i["items"]) {
                if (j.label.text==="Modifica materiale") {ce=true}
                if (j.label.text==="Tavola"){ce2=true}


            }
        }
        else {
            if (i.label){if (i.label.text==="Stato lezione"){ce3=true}}
        }
      }
      if (!ce){
      ite[0]["items"]=[...ite[0]["items"],{
        colCountByScreen:{lg: 2, xs: 2},
        colSpan:2,
        itemType:"group",
        items:[istrutt,{label: { text: "Modifica materiale",location:"top" },
      editorType: "dxSwitch",
      dataField: "showAdvanced",
      editorOptions:{
      elementAttr: {
                id: "val_mod_mat_switch"
              },
      onValueChanged: async function(ev) {
      form.itemOption("mainGroup.gruppoMateriale2.tipo_us", "visible", ev.value);
      form.itemOption("mainGroup.gruppoMateriale.kite_us", "visible", ev.value);
      form.itemOption("mainGroup.gruppoMateriale.barra_us", "visible", ev.value);
      form.itemOption("mainGroup.gruppoMateriale2.tavola_us", "visible", ev.value);
      const materiali_gen = await materialeDisponibile({dataInizio:inizio_2,dataFine:fine_2,idEsclusi:[e.appointmentData.Kite,e.appointmentData.Barra,e.appointmentData.Tavola],})
      const dati_materiall = materiali_gen[1]
      const dati_barraa = materiali_gen[2]
      const dati_tavolaa = materiali_gen[e.appointmentData.tipoT?e.appointmentData.tipoT:3]
      $("#val_kite").dxLookup("option","dataSource",dati_materiall)
      $("#val_barra").dxLookup("option","dataSource",dati_barraa)
      $("#val_tavola").dxLookup("option","dataSource",dati_tavolaa)
        }}
     }]

        }]}

      if (!ce3){
      let dati_stati = [];
    for (let i = 1; i <= 4; i++) {
      dati_stati.push({ ID: i, nome: status_lezione(i) });
    }
        ite[0]["items"].splice(3, 0,
        {colSpan:2,
        visible:true,
        dataField:"stato",
        label:{text:"Stato lezione"},
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: dati_stati,
            displayExpr: "nome",
            valueExpr: "ID",
            value:e.appointmentData.stato?e.appointmentData.stato:1,
            elementAttr: {
                id: "val_status"
              }
          }
        }
        )
      }
      if (!ce2){
      ite[0]["items"]=[...ite[0]["items"],tipo_box]
      ite[0]["items"]=[...ite[0]["items"],tipo2]
      }
      form.option('items',ite)
       $("#loadingOverlay").hide()
      },0)
      },
      onAppointmentAdded: async function(e) {
      $("#loadingOverlay").show()

        const dati_n={"lessondaterecurrencerules":e.appointmentData.recurrenceRule,"lessonid":e.appointmentData.text,'userid':e.appointmentData.userid,"lessondatestatus":e.appointmentData.stato,"lessondatestart":isoToString(e.appointmentData.startDate.toISOString()),"lessondateend":isoToString(e.appointmentData.endDate.toISOString())};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:dati_n,
               azione:'setLessonDate'})
            let idLez=richiesta.lessondateid

        if (e.appointmentData.showAdvanced){
        const idDatabase=[e.appointmentData.KiteNuovo,e.appointmentData.BarraNuovo,e.appointmentData.TavolaNuovo]
            for (let idKite of idDatabase){
                if (idKite){
                const divInt=idKite
                    const dati_n={"inventoryid": divInt, "lessondateid":idLez}
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    azione:'setLinkLessonDateInv'
                  });}
            }}
        fetchData()
        $("#loadingOverlay").hide()

      },
      onAppointmentAdding: function(e) {
  // aggiungo il valore che mi ero salvato altrove
  e.appointmentData.KiteNuovo = $("#val_kite").dxLookup("option", "value");
  e.appointmentData.BarraNuovo = $("#val_barra").dxLookup("option", "value");
  e.appointmentData.TavolaNuovo = $("#val_tavola").dxLookup("option", "value");
},
      onAppointmentRendered: function(e) {
      if (e.targetedAppointmentData.stato===1)
    e.appointmentElement
      .find(".dx-scheduler-appointment-title")
      .css("color", "yellow");
  },
      onAppointmentUpdated: async function(e) {
      setTimeout(async function(){
      //console.log($("#schedulerElement").dxScheduler("instance").option("dataSource"))
      const duplic=trovaIdDuplicati($("#schedulerElement").dxScheduler("instance").option("dataSource"))
      const duplicati=(JSON.stringify(duplic) !== JSON.stringify({})) ? true : false
      if (duplicati){
        for (let i of duplic[Object.keys(duplic)[0]]){
            if (i.recurrenceRule){
                const dati_n={'lessondaterecurrenceexception':i.recurrenceException};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:i.id,
                valori:dati_n,
                azione:'setLessonDate'})
            }
            else {
                const dati_n={"lessonid":i.lessonid,'userid':i.userid,"lessondatestatus":i.stato,"lessondatestart":isoToString(i.startDate.toISOString()),"lessondateend":isoToString(i.endDate.toISOString())};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
               token: getToken(),
               logout_on_error: true,
               valori:dati_n,
               azione:'setLessonDate'})
            }
        }
      }
      else {
          if (daEliminare) {
          $("#loadingOverlay").show()
            const lezioTot = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLessonDates",
            })
            var lezioni=[]
            for (let i of lezioTot) {
                if (i.lessondatestatus===1 || i.lessondatestatus===2){
                    lezioni=[...lezioni,i]
                }
            }
            var uguali=[]
            for (let i of lezioni) {
                if (daEliminare.userid===i.userid && i.lessondatestart===isoToString(daEliminare.startDate.toISOString()) && i.lessondateend===isoToString(daEliminare.endDate.toISOString()) && i.lessondatestatus===daEliminare.stato){
                    var richiesta = await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    logout_on_error: true,
                    delId:i.lessondateid,
                    azione:'delLessonDate'})
                }
            }
            const dati_n={'lessondaterecurrenceexception':e.appointmentData.recurrenceException};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.appointmentData.id,
                valori:dati_n,
                azione:'setLessonDate'})
          }
          else {
            const dati_n={'userid':e.appointmentData.userid,"lessondatestatus":e.appointmentData.stato,"lessondatestart":isoToString(e.appointmentData.startDate.toISOString()),"lessondateend":isoToString(e.appointmentData.endDate.toISOString()),"lessondaterecurrencerules":e.appointmentData.recurrenceRule,"lessondaterecurrenceexception":e.appointmentData.recurrenceException};
            var richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                setId:e.appointmentData.id,
                azione:'setLessonDate'})
        if (e.appointmentData.showAdvanced){
        var contatore=0
        const mappaValori={0:e.appointmentData.Kite,1:e.appointmentData.Barra,2:e.appointmentData.Tavola}
        const inventario={0:e.appointmentData.kiteLettera,1:e.appointmentData.barraLettera,2:e.appointmentData.tavolaLettera}
        const idDatabase=[e.appointmentData.linkKite,e.appointmentData.linkBarra,e.appointmentData.linkTavola]
            for (let idKite of idDatabase){
                const divInt=mappaValori[contatore]
            //Kite: se non c'è, o c'è ma è diverso, aggiungo/modifico, se il campo è vuoto ma c'è nel DB elimino, se non c'è e il campo è vuoto faccio nulla
                if (!divInt && inventario[contatore]) {
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    delId:idKite,
                    azione:'delLinkLessonDateInv'})

                }
                else {
                if (!idKite) {
                    const dati_n={"inventoryid": divInt, "lessondateid":e.appointmentData.id }
                    var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    azione:'setLinkLessonDateInv'
                  });}
                else {
                    const dati_n={"inventoryid": divInt, "lessondateid":e.appointmentData.id }
                    var richiesta = await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    setId:idKite,
                    azione:'setLinkLessonDateInv'})
                    }

                }

            contatore+=1
            }}
          }
      }
      if (modificaForm){
        fetchData()
      }
      modificaForm=false
      },0)
      },
      onOptionChanged: function (e) {
        if (e.name === "currentDate" || e.name==="currentView") {
         setTimeout(() => {
          fetchData();},0)
        }
      },
      appointmentTooltipTemplate: function(model, index, container) {
    const { appointmentData } = model;
    // Tooltip base
    const content = document.createElement("div");
    content.style.padding = "10px";

    // Testo
    content.innerHTML = `
      <div style="font-size:20px;">
  <strong>${appointmentData.text}</strong>
  ${appointmentData.stato === 1
    ? '<i class="fas fa-calendar-check"></i>'
    : '<i class="fas fa-check"></i>'}
</div>
      <div style= margin-top:2px;">Orario: ${new Date(model.targetedAppointmentData.startDate).toISOString().substring(11, 16)} - ${new Date(model.targetedAppointmentData.endDate).toISOString().substring(11, 16)}</div>
      ${appointmentData.Kite ? `<div style="font-size:14px; margin-top:10px;"><strong>Kite:</strong> ${appointmentData.kiteLettera}</div>`:""}
      ${appointmentData.Barra ? `<div style="font-size:14px;"><strong>Barra:</strong> ${appointmentData.barraLettera}</div>`:""}
      ${appointmentData.Tavola ? `<div style="font-size:14px;"><strong>Tavola:</strong> ${appointmentData.tavolaLettera}</div>`:""}
    `;

    // Pulsanti container
    const buttons = document.createElement("div");
    buttons.style.display = "flex";
    buttons.style.gap = "10px";

    // Pulsante DevExtreme "Delete" (mantieni quello originale)
    const deleteButton = $("<div>").dxButton({
      icon: "trash",
      stylingMode: "text",
      onClick: function (e) {
      e.event.stopPropagation();
        $("#schedulerElement").dxScheduler("instance").hideAppointmentTooltip()
        confermaEliminazione(appointmentData)
      }
    });

    // 🔧 Pulsante personalizzato "Modifica materiale"
    const editMaterialButton = $("<div>").dxButton({
      text: appointmentData.Kite?"✏️🪁" : "➕️🪁",
      stylingMode: "text",
      onClick: function (e) {
     e.event.stopPropagation();
        // Qui chiama la tua logica per modificare il materiale
        $("#schedulerElement").dxScheduler("instance").hideAppointmentTooltip()
        modificaKite([appointmentData.Kite,appointmentData.Barra,appointmentData.Tavola,appointmentData.tipoT],appointmentData.text,appointmentData.startDate,appointmentData.endDate,appointmentData.tipoT,[appointmentData.linkKite,appointmentData.linkBarra,appointmentData.linkTavola],appointmentData.id)
      }
    });
    const editExceptions = $("<div>").dxButton({
      icon: "preferences",
      stylingMode: "text",
      hint:"Modifica eccezioni",
      onClick: function (e) {
     e.event.stopPropagation();
     modificaEccezioniF(appointmentData)
        $("#schedulerElement").dxScheduler("instance").hideAppointmentTooltip()

      }
    });
    const confirm = $("<div>").dxButton({
      icon: appointmentData.stato===1 ? "check" :"event",
      stylingMode: "text",
      hint: appointmentData.stato===1 ? "Conferma lezione" :"Segna come non confermata",
      onClick: function (e) {
      e.event.stopPropagation();
        modificaStatus(appointmentData)
        $("#schedulerElement").dxScheduler("instance").hideAppointmentTooltip()

      },

    });
    if (appointmentData.recurrenceRule) {
    $(buttons).append(deleteButton,editExceptions);}
    else {
    $(buttons).append(editMaterialButton, deleteButton,confirm)
    }
    $(container).append(content, buttons);
  },
  onAppointmentDeleted: async function (e) {
   var richiesta = await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    logout_on_error: true,
                    delId:e.appointmentData.id,
                    azione:'delLessonDate'})
  },

    });

    $("#modificaLezione").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#modificaMateriale").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#modificaStato").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#confermaElimina").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
    $("#buttonMessages").dxButton({
    text: "Manda SMS",
  type: "default",
  icon: "email",
  onClick: async function (e){
    scegliSMS()
  }
    })
    $("#confermaSMS").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
    $("#customScroll").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
    });
    $("#confermaSMS2").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll3" style="height: 100%; max"></div>');
    $("#customScroll3").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
    });
    $("#confermaSMSPlan").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScroll2" style="height: 100%; max"></div>');
    $("#customScroll2").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
}
    });
    $("#modificaEccezioni").dxPopup({
    width: "70%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onHiding: function(e) {
    fetchData()
    // qui metti il codice che vuoi eseguire alla chiusura
  }
    });
    fetchData();

  }, []);
  const fetchData = async () => {
        $("#loadingOverlay").show()
        let totaleOre=0

        const pacchetti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLessons",

            })
        const utenti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getUsers",
            })
        let date=$("#schedulerElement").dxScheduler("instance").getStartViewDate()

        date=date.toISOString()
        date=convertDate(DateTime.fromISO(date))
        let date2=$("#schedulerElement").dxScheduler("instance").getEndViewDate()

        date2=date2.toISOString()
        if ($("#schedulerElement").dxScheduler("instance").option("currentView")!=="day")
        date2=convertDate(DateTime.fromISO(date2).plus({days:1}))
        else date2=convertDate(DateTime.fromISO(date2))
        const dt1 = DateTime.fromFormat(date, "yyyyLLdd");
        const dt2 = DateTime.fromFormat(date2, "yyyyLLdd");

        if (dt1.hasSame(dt2, 'day')) {
          const dt2Plus1 = dt2.plus({ days: 1 });
          date2= dt2Plus1.toFormat("yyyyLLdd");
        }
        const lezio1 = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getLessonDates",
                filtri: {"lessondatesfrom":date,"lessondatesto":date2,},
                childs:["inventories"]
            })
        var lezio=[]
        for (let i of lezio1) {
            if (i.lessondatestatus===1 || i.lessondatestatus===2){
                lezio=[...lezio,i]
            }
        }
        var lezioni=[]
        var istrId=[]
        var minimo=null
        var massimo=null
        let durataMassima=null
        const typeMap = {
          1: convertiIdInventario(1),
          2: convertiIdInventario(2),
          3: "Tavola",
          4:"Tavola",
          5:"Tavola",
        };
        if (lezio.length>0){
            for (let lezione of lezio) {
                let inventario = {};
                for (let i of lezione.inventories) {
                  const key = typeMap[i.inventorytype];
                  if (key) inventario[key] = i;
                }
                let nome=""
                let lingua=0
                let telefono=""
                for (let pacchetto of pacchetti){
                    if (pacchetto.lessonid===lezione.lessonid){
                        nome=pacchetto.lessonstudentname
                        lingua=getIDLingua(getLinguaMessaggio(pacchetto.lessonstudentorigin))
                        telefono=pacchetto.lessonstudentphone
                    }
                }
                const appointment={
                    id:lezione.lessondateid,
                    text: nome,
                    startDate: new Date(convertDate(lezione.lessondatestart).toISO({ includeOffset: false })+"Z"),
                    endDate: new Date(convertDate(lezione.lessondateend).toISO({ includeOffset: false })+"Z"),
                    userid:lezione.userid,
                    Kite:inventario.Kite?inventario.Kite.inventoryid:null,
                    Barra:inventario.Barra?inventario.Barra.inventoryid:null,
                    Tavola: inventario.Tavola? inventario.Tavola.inventoryid : null,
                    tipoT:inventario.Tavola ? inventario.Tavola.inventorytype : 3,
                    lessonid:lezione.lessonid,
                    stato:lezione.lessondatestatus,
                    kiteLettera:inventario.Kite?`${inventario.Kite.inventorybrand} ${inventario.Kite.inventorymeasure} ${inventario.Kite.inventorydescr} ${inventario.Kite.inventoryyear}`:null,
                    barraLettera:inventario.Barra ? `${inventario.Barra.inventorybrand} ${inventario.Barra.inventorymeasure} ${inventario.Barra.inventorydescr} ${inventario.Barra.inventoryyear}`:null,
                    tavolaLettera:inventario.Tavola?`${inventario.Tavola.inventorybrand} ${inventario.Tavola.inventorymeasure} ${inventario.Tavola.inventorydescr} ${inventario.Tavola.inventoryyear}`:null,
                    linkKite:inventario.Kite ? inventario.Kite.lessondateinvid : null,
                    linkBarra: inventario.Barra? inventario.Barra.lessondateinvid : null,
                    linkTavola: inventario.Tavola ? inventario.Tavola.lessondateinvid : null,
                    recurrenceRule: lezione.lessondaterecurrencerules,
                    recurrenceException:lezione.lessondaterecurrenceexception,
                    recurringAppointmentId :null,
                    lingua:lingua,
                    telefono:telefono


                  }
                lezioni=[...lezioni,appointment,]
                var lezioniMultiple=[]
                if (appointment.recurrenceRule){
                const dayStart = convertDate(date);
                const dayEnd = convertDate(date2)
                lezioniMultiple = getOccurrences(appointment, dayStart, dayEnd);
                // Ora calcola il minimo inizio e massimo fine orario

                lezioniMultiple.forEach(o => {
                  if (!minimo || parseInt(o.startDate.slice(8,10)) < minimo) minimo = parseInt(o.startDate.slice(8,10));
                  if (!massimo || parseInt(o.endDate.slice(8,10)) > massimo) {massimo = parseInt(o.endDate.slice(8,10));}
                  if (!durataMassima || parseInt(o.endDate.slice(8,10))-parseInt(o.startDate.slice(8,10))>durataMassima) durataMassima=parseInt(o.endDate.slice(8,10))-parseInt(o.startDate.slice(8,10))
                  if (!istrId.includes(o.userid))  istrId=[...istrId,o.userid]
                });}
                if (!istrId.includes(lezione.userid))  istrId=[...istrId,lezione.userid]
                const inizio=parseInt((lezione.lessondatestart).slice(8,10))
                let fine
                if ((lezione.lessondateend).slice(10,12)==="00") fine=parseInt((lezione.lessondateend).slice(8,10))
                else fine=parseInt((lezione.lessondateend).slice(8,10))+1
                if (!durataMassima || parseInt(lezione.lessondateend.slice(8,10))-parseInt(lezione.lessondatestart.slice(8,10))>durataMassima) durataMassima=parseInt(lezione.lessondateend.slice(8,10))-parseInt(lezione.lessondatestart.slice(8,10))
                totaleOre+=(convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))
                if (!minimo || inizio<minimo){
                minimo=inizio}
                if (!massimo || fine>massimo){
                massimo=fine
                }

        }



        }
        else {$("#schedulerElement").dxScheduler("instance").option({
      startDayHour: 8,
      endDayHour: 20
    });
            }
        let risorse=[]
        var paletteAzzurri = [
          "#0077b6", "#0096c7", "#00b4d8", "#48cae4", "#90e0ef",
          "#ade8f4", "#caf0f8", "#61a5c2", "#468faf", "#2c7da0"
        ];
        let contatore=0
        const el = document.getElementById("comment-box");
        el.innerText=`Ore totali della giornata: ${differenzaOrario({dataInizio:totaleOre})}`
        el.style.fontFamily="Poppins, sans-serif";
        el.style.fontSize="20px"
        el.style.fontWeight="bold"
        el.style.marginTop="10px"
        for (let i of istrId) {
            risorse=[...risorse,{id:i,text:nome_id({id:i,utenti:utenti}),color:contatore<paletteAzzurri.length? paletteAzzurri[contatore] : coloreDaId(i)}]
            contatore+=1
        }

        $("#schedulerElement").dxScheduler("instance").option("resources", [{
          fieldExpr: "userid",
          dataSource: risorse,
          label: "Istruttore"
        }]);
        $("#schedulerElement").dxScheduler("instance").option("groups", ["userid"])
        $("#schedulerElement").dxScheduler("instance").option("dataSource",lezioni)

try {
if (minimo < massimo) {
  if (durataMassima === massimo - minimo) {
    let start = minimo - 1;
    let end = massimo + 1;

    if (start < 0) start = 0;
    if (end > 23) end = 23;
    $("#schedulerElement").dxScheduler("instance").option({
      startDayHour: start,
      endDayHour: end
    });
  } else {
    $("#schedulerElement").dxScheduler("instance").option({
      startDayHour: minimo,
      endDayHour: massimo
    });
  }
}}
catch (e) {
  console.warn("Non è stato possibile impostare gli orari:", e.message);
  try {
  $("#schedulerElement").dxScheduler("instance").option({
      startDayHour: minimo-2,
      endDayHour: massimo+2
    });}
  catch (e) {
  $("#schedulerElement").dxScheduler("instance").option({
      startDayHour: 8,
      endDayHour: 19
    });
  }
}
        var startDate = new Date(2025, 4, 23, 0, 0, 0);
var endDate = new Date(2025, 4, 23, 23, 59, 59);

// Prendo tutti gli appuntamenti (compresi quelli ricorrenti espansi) nell'intervallo
         $("#loadingOverlay").hide()

        }

  return <div>
            <div style={{display : "flex",flexDirection : "row",justifyContent : "space-between",alignItems : "center"}}>
            <h2>Agenda lezioni</h2>
            <div id="buttonMessages"/>
            </div>
            <div id="schedulerElement" style={{borderRadius:"15px",border:"0px solid black"}}/>
            <div id="modificaLezione" />
            <div id="confermaSMS" />
            <div id="confermaSMS2" />
            <div id="confermaSMSPlan" />
            <div id="modificaMateriale" />
            <div id="confermaElimina" />
            <div id="modificaStato" />
            <div id="modificaEccezioni"/>
            <div id="comment-box"></div>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
         </div>
}

export default Agenda;